import GetCommentListResponse from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/response/GetCommentListResponse";
import GetCommentListRequest from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/request/GetCommentListRequest";
import CreateTaskCommentRequest from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/CreateTaskCommentRequest";
import RemoveTaskCommentRequest from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/RemoveTaskCommentRequest";
import UpdateCommentRequest from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/request/UpdateCommentRequest";
import {
  CommentChatMessageModel,
  CreateCommentFileFolderModel,
  CreateCommentModel,
  CreateCommentResultModel,
  OnUpdateCommentModel,
  RemoveFileFromCommentModel,
  UpdateCommentModel,
  UserModel,
} from "../models";
import TaskCommentResponse from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/TaskCommentResponse";
import { PaginationRequestModel } from "@/models";
import PageRequest from "@/api/Main/dataSource/api/pagination-helper/lib/PageRequest";
import GetCommentListItem from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/response/GetCommentListItem";
import OnUpdateCommentResponse from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/response/OnUpdateCommentResponse";
import { CommentFileModel } from "../models/CommentFileModel";
import FileResponse from "@/api/Main/dataSource/api/pm/files/ws-client/models/response/FileResponse";
import FolderPathTypeEnum from "@/api/File/dataSource/api/pm/common/enums/FolderPathTypeEnum";
import CreateFolderWithoutEntityRequest from "@/api/File/dataSource/api/project-manager/files/i-services/models/request/CreateFolderWithoutEntityRequest";
import RemoveFilesCommentRequest from "@/api/Main/dataSource/api/projects/task-comments/i-service/models/request/RemoveFilesCommentRequest";
import StatusFileEnum from "@/api/Main/dataSource/api/pm/files/ws-client/models/enums/StatusFileEnum";

export const mapGetCommentTaskRequest = (taskId: number, page?: PaginationRequestModel) =>
  new GetCommentListRequest({
    TaskId: taskId,
    Page: new PageRequest({
      Skip: page.Skip,
      Take: page.Take,
    }),
  });

export const mapGetCommentsResponse = (response: GetCommentListResponse) => {
  return response.Items.map(mapGetCommentListItem);
};

const mapFileResponse = (file: FileResponse) => {
  return new CommentFileModel({
    Id: file.Id,
    Name: file.Name,
    Size: file.Size,
    Url: file.Url,
    ThumbnailUrl: file.ThumbnailUrl,
    DateCreated: new Date(file.DateCreated),
    IsProccessing: file.Status === StatusFileEnum.Proccessing
  });
};

export const mapGetCommentListItem = (item: GetCommentListItem) => {
  return new CommentChatMessageModel({
    Id: item.Id,
    ReplyComment: item.ParentComment ? mapGetCommentListItem(item.ParentComment) : undefined,
    Message: item.Comment,
    DateCreate: new Date(item.DateCreate),
    Author: new UserModel({
      Id: item.Owner.UserId,
      FirstName: item.Owner.FirstName,
      LastName: item.Owner.LastName,
      MiddleName: item.Owner.MiddleName,
      AvatarColor: item.Owner.AvatarColor,
      ImageUrl: item.Owner.Foto,
    }),
    File: item.Files?.length ? mapFileResponse(item.Files[0]) : undefined,
    FileFolderId: item.FolderId,
  });
};

export const mapCreateCommentTaskRequest = (request: CreateCommentModel) =>
  new CreateTaskCommentRequest({
    TaskId: request.TaskId,
    ProjectId: request.ProjectId,
    ParentId: request.ParentCommentId,
    Text: request.Text,
    FolderId: request.FolderId,
  });

export const mapCreateCommentResponse = (response: TaskCommentResponse) =>
  new CreateCommentResultModel({
    CommentId: response.Id,
    ParentCommentId: response.ParentId,
    DateCreate: new Date(response.DateCreate),
    Text: response.Text,
  });

export const mapUpdateCommentTaskRequest = (request: UpdateCommentModel) =>
  new UpdateCommentRequest({
    CommentId: request.CommentId,
    Text: request.Text,
  });

export const mapDeleteCommentTaskRequest = (commentId: number) =>
  new RemoveTaskCommentRequest({
    CommentId: commentId,
  });

export const mapOnUpdateCommentResponse = (resp: OnUpdateCommentResponse) =>
  new OnUpdateCommentModel({
    Id: resp.CommentId,
    Message: resp.Comment,
    File: resp.Files?.length ? mapFileResponse(resp.Files[0]) : undefined,
  });

export const mapCreateFolderWithoutEntityRequest = (request: CreateCommentFileFolderModel) =>
  new CreateFolderWithoutEntityRequest({
    ProjectId: request.ProjectId,
    TaskId: request.TaskId,
    Type: FolderPathTypeEnum.Comment,
  });

export const mapRemoveFileComment = (request: RemoveFileFromCommentModel) =>
  new RemoveFilesCommentRequest({
    CommentId: request.CommentId,
    FilesIds: [request.FileId],
  });
